export const DPIA_CRITERIA_VERSION = 'imy_edpb_v1';

/** Backend CharField limit on each criteria_codes list item. */
export const DPIA_CRITERIA_CODE_MAX_LENGTH = 16;

/**
 * Stable screening codes must be ≤ DPIA_CRITERIA_CODE_MAX_LENGTH (BE constraint).
 * Labels stay in i18n; these are storage/API codes only.
 */
export const DPIA_SCREENING_CRITERION_CODES = [
  'sys_eval_profile',
  'auto_sig_decide',
  'sys_monitoring',
  'sensitive_data',
  'large_scale',
  'match_datasets',
  'vuln_subjects',
  'innov_tech_use',
  'prevent_rights',
  'other_high_risk',
] as const;

/** Maps older long codes (Use case J draft names) to BE-compatible codes. */
export const DPIA_SCREENING_CRITERION_CODE_ALIASES: Record<string, typeof DPIA_SCREENING_CRITERION_CODES[number]> = {
  systematic_evaluation_or_profiling: 'sys_eval_profile',
  automated_significant_decisions: 'auto_sig_decide',
  systematic_monitoring: 'sys_monitoring',
  sensitive_or_highly_personal_data: 'sensitive_data',
  large_scale_processing: 'large_scale',
  matching_or_combining_datasets: 'match_datasets',
  vulnerable_data_subjects: 'vuln_subjects',
  innovative_technology_or_use: 'innov_tech_use',
  prevents_rights_services_or_contracts: 'prevent_rights',
  other_high_risk_criterion: 'other_high_risk',
};

export const DPIA_TRIGGER_SOURCE_OPTIONS = [
  'asset_owner_indication',
  'ropa_administrator',
  'formal_ropa_review',
  'project_or_change',
  'periodic_reassessment',
  'other',
] as const;
